import { httpGet } from "../../../../../common/network/fetch";
import { GetFinalizedReturnRequestQuery } from "./get-finalized-return-request-query";
import { BtmReturnRequestListItem } from "../../model/btm-return-request-list-item";
import { IBtmReturnRequestListDto } from "../../model/btm-return-request-list";

export const GetFinalizedReturnRequestsHandler = async (query: GetFinalizedReturnRequestQuery) => {
    return (await httpGet<IBtmReturnRequestListDto>({ url: `/return-request/list/warehouse/${query.warehouseCode}` }, false))
        .returnRequestListItems
        .filter(dto => dto.status === "Accepted"
            || dto.status === "AutomaticallyAccepted"
            || dto.status === "PartiallyAccepted"
            || dto.status === "Rejected")
        .map(dto => new BtmReturnRequestListItem(dto));
};
